import React from "react";
import WorkCard from "./WorkCard";
import styles from "./work.module.scss";

interface WorkProps {
  workRef: React.RefObject<HTMLDivElement>;
}

const Work: React.FC<WorkProps> = ({ workRef }) => {
  return (
    <div className={styles.work} ref={workRef}>
      <div className={styles.label}>Our work</div>
      <div className={styles.title}>Explore our work</div>

      <div className={styles.workColumn}>
        <div className={styles.workRow}>
          <WorkCard
            url="https://thecuza.co.uk/"
            title="The Cuza – Manchester Rock Band"
          />
          <WorkCard
            url="https://www.editurapleiade.ro/"
            title="Acolada – Romanian Literary Magazine"
          />
          <WorkCard
            url="https://www.cresasm.ro/"
            title="Satu Mare County Nurseries"
          />
          <WorkCard
            url="https://abcautostart.com/"
            title="ABC Auto Start - Driving School"
            img="images/abc2.png"
          />
        </div>
      </div>
    </div>
  );
};

export default Work;
